import { t } from "@lingui/core/macro"

/**
 * Descripteur de protocole iframe pour Nedarim Plus (Matara).
 * Modèle B / sample2.html : la carte est saisie DANS l'iframe ; le paiement est
 * déclenché par un bouton de NOTRE page (autoPay:false) qui envoie FinishTransaction2.
 *
 * Le composant générique <PaymentIframe> ne connaît AUCUN de ces noms de messages :
 * il appelle uniquement les fonctions de ce descripteur. Pour ajouter une plateforme
 * iframe, créer un descripteur similaire et l'enregistrer dans ./index.js.
 *
 * Contrat attendu par <PaymentIframe> :
 * - buildSrc(params)        : URL src de l'iframe
 * - iframeId, title, sandbox, heightPadding
 * - autoPay                 : true = payer dès que l'iframe est prête ; false = attendre le clic
 * - onReady()               : messages à poster au onload (handshake) — tableau
 * - parseMessage(event)     : normalise un message entrant → {kind, height?, message?, value?}
 * - buildPayMessage(params) : message à poster pour déclencher le paiement
 * - debugWarning            : (optionnel) texte d'alerte affiché en DEBUG
 */
const nedarimProtocol = {
    id: "NEDARIM",

    iframeId: "NedarimFrame",
    title: "Nedarim Plus",
    sandbox: "allow-scripts allow-same-origin allow-forms allow-popups",
    heightPadding: 15,
    autoPay: false,

    buildSrc(params) {
        const base = params?.iframeUrl || "https://matara.pro/nedarimplus/iframe"
        return base + "?language=en"
    },

    onReady() {
        // Demander la hauteur déclenche le handshake (l'iframe répond par 'Height').
        return [{ Name: "GetHeight" }]
    },

    parseMessage(event) {
        const data = event?.data
        if (!data || !data.Name) {
            return { kind: "ignore" }
        }

        switch (data.Name) {
            case "Height":
                return { kind: "height", height: parseInt(data.Value) }

            case "TransactionResponse":
                if (data.Value?.Status === "Error") {
                    return { kind: "error", message: data.Value?.Message, value: data.Value }
                }
                return { kind: "success", value: data.Value }

            default:
                return { kind: "ignore" }
        }
    },

    buildPayMessage(params) {
        // `params` = l'objet params.nedarim renvoyé par le backend, passé tel quel.
        return { Name: "FinishTransaction2", Value: params }
    },

    get debugWarning() {
        return t`L'iframe Nedarim (postMessage) ne fonctionne pas en localhost. Testez sur un vrai domaine (staging).`
    },
}

export default nedarimProtocol
